import React from 'react';
import { Field } from 'react-final-form';
import css from './SectionOfferingsForm.module.css'; // optional – you can reuse existing CSS if you want
import { FieldTextInput } from '../../../components';

const HashtagsFormField = ({ label, placeholder }) => {
  return (
    <Field name="hashtags">
      {({ input, meta }) => (
        <FieldTextInput
          {...input}
          id="hashtags"
          type="textarea"
          label={label}
          placeholder={placeholder}
        />
      )}
    </Field>
  );
};

export default HashtagsFormField;
